module.exports = __webpack_public_path__ + "static/media/screen2.a89759b5.png";